import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({

})
export default class Input extends Vue {

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: String, default: 'search' }) type!: string;
    @Prop({ type: String, default: '팀명이나 이름을 입력하세요.' }) placeholder!: string;
    @Prop({ type: String }) value!: string;

}